export default String.raw`
{% comment %}
    Normalizuje link wpisany przez klienta (banery, komunikaty, widgety itp.).
    Parametry: userLink - link z panelu, userBase (opcjonalnie) - base do uzycia zamiast page.BaseHref (np. wewnatrz petli "for page in").
    - www.strona.pl: dopisuje https://
    - https://..., //..., #kotwica oraz inne schematy (mailto:, tel:, sms:, skype:, javascript: itd.): bez zmian
    - sciezka: page.BaseHref + sciezka (z uwzglednieniem wersji jezykowej; poczatkowe ./ jest usuwane)
    - /sciezka: //domena/sciezka (od korzenia domeny, tak jak przegladarka; np. page.Url biezacej strony);
      domena brana z base (page.BaseHref / userBase), a gdy sie nie da - z config.Url
    Cel: wynik nigdy nie jest wzgledny (poza samym #kotwica).
    Uzycie: wynik include'a przechwycic przez capture do zmiennej (np. bannerHref) przed tagiem,
    a w atrybucie (href, action, data-url) wstawic juz tylko te zmienna.
{% endcomment -%}

{% if userBase -%}
    {% assign ulBase = userBase -%}
{% else -%}
    {% assign ulBase = page.BaseHref -%}
{% endif -%}

{% assign ulFirst1 = userLink | Slice: 0, 1 -%}
{% assign ulFirst2 = userLink | Slice: 0, 2 -%}
{% assign ulFirst4 = userLink | Slice: 0, 4 | Downcase -%}

{% comment %} schemat (https:, mailto:, tel:, sms:, skype:, javascript: itd.) - tekst przed pierwszym dwukropkiem musi wygladac jak schemat (litera, potem litery/cyfry/+.-), inaczej np. "promocje?od=10:00" to zwykla sciezka {% endcomment -%}
{% assign ulIsScheme = false -%}
{% if userLink contains ':' -%}
    {% assign ulScheme = userLink | Split: ':' | First -%}
    {% assign ulSchemeRest = ulScheme | Replace: '^[a-zA-Z][a-zA-Z0-9+.-]*$', '' -%}
    {% if ulScheme != '' and ulSchemeRest == '' -%}
        {% assign ulIsScheme = true -%}
    {% endif -%}
{% endif -%}

{% comment %} domena dla sciezek od korzenia {% endcomment -%}
{% if ulBase contains '//' -%}
    {% assign ulHost = ulBase | Split: '//' | Last | Split: '/' | First -%}
{% else -%}
    {% assign ulHost = config.Url | Split: '//' | Last | Split: '/' | First -%}
{% endif -%}

{% if userLink == null or userLink == '' -%}{% elsif ulFirst4 == 'www.' -%}https://{{ userLink }}{% elsif ulFirst1 == '#' or ulFirst2 == '//' or ulIsScheme == true -%}{{ userLink }}{% elsif ulFirst1 == '/' -%}//{{ ulHost }}{{ userLink }}{% else -%}{{ ulBase }}{{ userLink | Replace: '^\./', '' }}{% endif -%}

`